import { Injectable, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TitleService implements OnDestroy {

  private titleName = 'Cirrus Client Portal'
  private titleSubscription: Subscription;

  constructor(
    private title: Title,
    private router: Router
  ) { }

  getDivisionName(): string {
    return this.titleName;
  }

  setDivisionName(name: string): void {
    this.titleName = name;
  }

  setPageTitle(pageTitle: string): void {
    this.title.setTitle(this.titleName ? `${pageTitle} | ${this.titleName}` : pageTitle);
  }

  getTitle(): string {
    return this.title.getTitle();
  }

  setTitles() {
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }

    this.titleSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          while (route!.firstChild) {
            route = route.firstChild;
          }
          return route.snapshot.data['title'] as string || '';
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.setPageTitle(title);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }
  }

}
